import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { Availability } from '../../entities/Availability';
import { toast } from 'react-toastify';
import { UploadPicture } from '../../features/UploadPicture/index.js';
import { LanguageOptions } from '../../entities/LanguageOptions/index.js';
import { SEOMetatagsForm } from '../../shared/ui/SEOMetatagsForm';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateNewsPage = () => {
  const [mainImg, setMainImage] = useState();
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: '',
    URL: '',
    shortDescription: '',
    mainLanguageId: 1,
    availability: {
      availableInAllCountries: true,
      allowedCountriesIds: [],
      disallowedCountriesIds: [],
    },
    SEOMetatags: {
      Title: null,
      Description: null,
      Keywords: null,
    },
  });

  const handleRequest = () => {
    // Проверка наличия главного изображения
    if (!mainImg) {
      toast.error('Необходимо загрузить главное изображение');
      return;
    }

    const body = new FormData();
    
    // Важно: имя файла должно быть именно 'mainImg' согласно требованиям API
    body.append('mainImg', mainImg, mainImg.name || 'image.jpg');
    body.append('model', JSON.stringify(form));
    
    // Отладочная информация
    console.log('Отправляемые данные:', {
      mainImage: mainImg ? { name: mainImg.name, size: mainImg.size, type: mainImg.type } : null,
      form: form
    });
    
    // Используем стандартный подход с then/catch вместо toast.promise для лучшей обработки ошибок
    const toastId = toast.loading('Запрос к серверу...');
    
    apiRequests.news.create(body)
      .then(response => {
        toast.update(toastId, { 
          render: 'Новость успешно создана', 
          type: 'success', 
          isLoading: false,
          autoClose: 3000
        });
        console.log('Ответ сервера:', response.data);
      })
      .catch(error => {
        // Получаем текст ошибки из ответа сервера
        const errorMessage = error.response?.data?.error || 
                           error.response?.data?.message || 
                           error.message || 
                           'Произошла ошибка при создании новости';
        
        toast.update(toastId, { 
          render: errorMessage, 
          type: 'error', 
          isLoading: false,
          autoClose: 5000
        });
        
        console.error('Ошибка при создании новости:', error.response?.data || error);
      });
  };

  return (
    <FormLayout
      onSubmit={handleRequest}
      onBack={() => navigate('/news')}
      saving={saving}
      submitText="Создать новость"
      savingText="Создание..."
    >
      <FormSection title="Основная информация">
        <Row>
          <Col lg={8}>
            <FormField label="Заголовок" required>
              <Form.Control
                type="text"
                value={form.title}
                onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
                placeholder="Новости компании"
              />
            </FormField>

            <FormField label="Текст">
              <Form.Control
                as="textarea"
                rows={3}
                value={form.shortDescription}
                onChange={(e) => setForm((prev) => ({ ...prev, shortDescription: e.target.value }))}
                placeholder="Введите текст новости"
              />
            </FormField>
          </Col>

          <Col lg={4}>
            <FormField label="Изображение" required>
              <UploadPicture onSelect={setMainImage} entityType="news" />
            </FormField>
          </Col>
        </Row>
      </FormSection>

      <FormSection title="Настройки">
        <Row>
          <Col lg={6}>
            <LanguageOptions
              onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))}
            />
          </Col>
        </Row>

        <div className="mt-4">
          <Availability
            onSelect={(val) =>
              setForm((prev) => ({
                ...prev,
                availability: { ...prev.availability, availableInAllCountries: val },
              }))
            }
            onSelectAllowed={(val) =>
              setForm((prev) => ({
                ...prev,
                availability: { ...prev.availability, allowedCountriesIds: val },
              }))
            }
            onSelectDisallowed={(val) =>
              setForm((prev) => ({
                ...prev,
                availability: { ...prev.availability, disallowedCountriesIds: val },
              }))
            }
          />
        </div>
      </FormSection>

      <FormSection title="SEO настройки">
        <SEOMetatagsForm
          seoMetatags={form.SEOMetatags}
          onChange={(metaTags) => setForm((prev) => ({ ...prev, SEOMetatags: metaTags }))}
        />
      </FormSection>
    </FormLayout>
  );
};

export default CreateNewsPage;
